/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ClaimApiConfiguration } from '../claim-api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { ClaimClaimIdAuthenticationRefreshPost200ResponseDto } from '../models/claim-claim-id-authentication-refresh-post-200-response-dto';


/**
 * the ClaCommandAuthenticationRefresh API
 */
@Injectable({
  providedIn: 'root',
})
export class ClaCommandAuthenticationRefreshService extends BaseService {
  constructor(
    config: ClaimApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation claimClaimIdAuthenticationRefreshPost
   */
  static readonly ClaimClaimIdAuthenticationRefreshPostPath = '/claim/{claimId}/authentication/refresh';

  /**
   * Refresh token.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `claimClaimIdAuthenticationRefreshPost()` instead.
   *
   * This method doesn't expect any request body.
   */
  claimClaimIdAuthenticationRefreshPost$Response(params: {
    claimId: string;
    'X-Authorization'?: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<ClaimClaimIdAuthenticationRefreshPost200ResponseDto>> {

    const rb = new RequestBuilder(this.rootUrl, ClaCommandAuthenticationRefreshService.ClaimClaimIdAuthenticationRefreshPostPath, 'post');
    if (params) {
      rb.path('claimId', params.claimId, {});
      rb.header('X-Authorization', params['X-Authorization'], {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ClaimClaimIdAuthenticationRefreshPost200ResponseDto>;
      })
    );
  }

  /**
   * Refresh token.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `claimClaimIdAuthenticationRefreshPost$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  claimClaimIdAuthenticationRefreshPost(params: {
    claimId: string;
    'X-Authorization'?: string;
  },
  context?: HttpContext

): Observable<ClaimClaimIdAuthenticationRefreshPost200ResponseDto> {

    return this.claimClaimIdAuthenticationRefreshPost$Response(params,context).pipe(
      map((r: StrictHttpResponse<ClaimClaimIdAuthenticationRefreshPost200ResponseDto>) => r.body as ClaimClaimIdAuthenticationRefreshPost200ResponseDto)
    );
  }

}
